import {
    IOfflineService,
    IPlayerHtmlEngine,
    IPlayerProperties,
    PlayerBase,
} from '@24i/player-base';
import { DashJsPlayer } from './DashJs';
import { Logger } from './Logger';

export class DashJsPlayerEngine implements IPlayerHtmlEngine {
    playerName: string = DashJsPlayer.playerName;

    playerVersion: string = DashJsPlayer.version;

    logger = Logger;

    constructor(customConfiguration?: any) {
        this.customConfiguration = customConfiguration;
    }

    async getSupportedFormats() {
        const formats = DashJsPlayer.SupportedFormats;
        await formats.initialize();
        return formats;
    }

    getOfflineService(): IOfflineService | undefined {
        return undefined;
    }

    createPlayer(
        config: IPlayerProperties,
        parentElement: HTMLElement,
        fullscreenContainer?: HTMLElement
    ): PlayerBase {
        return new DashJsPlayer(config, parentElement, fullscreenContainer);
    }
}